import { creditsFromKieCredits } from '@/config/credit-economics';

/** @deprecated Old scale. New charges use `creditsFromKieCredits`. */
export const FRONTEND_CREDITS_PER_KIE_CREDIT = 4;
export const IMAGE_MINIMUM_CREDITS = 1;
export const VIDEO_MINIMUM_CREDITS = 1;

export function niceRoundFrontCredits(value: number): number {
  if (!Number.isFinite(value) || value <= 0) {
    return 0;
  }

  const unit = value < 100 ? 5 : 10;
  return Math.max(unit, Math.round(value / unit) * unit);
}

export function calculateFrontendCreditsFromKie({
  kieCredits,
  riskFactor = 1,
}: {
  kieCredits: number;
  minimumCredits?: number;
  riskFactor?: number;
}): number {
  return creditsFromKieCredits(kieCredits * riskFactor);
}

export function formatMinimumCreditLabel(credits: number): string {
  return `${credits}+`;
}
